/** Works for Swedishpostal code format */
export const formatPostalCode = (value: string) => {
  if (value.length === 4 && value[3] === ' ') {
    return value;
  }

  let newValue = value.replace(/\D/g, '');
  if (newValue.length > 3) {
    newValue = `${newValue.slice(0, 3)} ${newValue.slice(3)}`;
  }
  return newValue;
};
